import React, { useState } from 'react';

import { Display } from 'src/services/responseTypes/singleLaunchResponse';
import { langaugeComparator } from 'src/utils/LanguageUtils';

import { useAppStore } from 'src/hooks/useAppStore';
import * as style from './DisplayLanguageStyles';
import { Row, Label, RadioButton } from './DisplayLanguageStyles';
import { getDisplayLanguageConfig } from '../../../services/apiRequests/launchApiHelper';

//types
type DisplayLanguagePropsType = {
  displayLanguage: string;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    name: string
  ) => void;
};

const DisplayLanguage = ({
  displayLanguage,
  handleChange
}: DisplayLanguagePropsType) => {
  const { initialLaunchData } = useAppStore();
  const displayLanguages = getDisplayLanguageConfig(initialLaunchData);

  const sortAndFormat = (languages: Display[] | undefined) => {
    return languages
      ?.map((language) => {
        return {
          ...language,
          is_default: language.l_code === displayLanguage ? true : false
        };
      })
      .sort(langaugeComparator);
  };

  const [selectedDisplayLanguages, setSelectedDisplayLanguages] = useState(
    sortAndFormat(displayLanguages)
  );

  const handleSelectionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    lCode: string
  ) => {
    setSelectedDisplayLanguages((ps) => {
      return ps?.map((language) => {
        return {
          ...language,
          is_default: lCode === language.l_code ? true : false
        };
      });
    });
    handleChange(event, lCode);
  };

  return (
    <>
      {selectedDisplayLanguages && selectedDisplayLanguages.length > 0
        ? selectedDisplayLanguages.map((language) => {
            return (
              <Row
                key={language.name}
                css={[language.is_default === true && style.active]}>
                <Label htmlFor={`content_${language.name}`}>
                  <div css={style.languageContainer}>
                    <div css={style.dot}></div>
                    <span css={style.langName}>{language.native}</span>
                    <span
                      css={style.commonName}
                      data-testid={language.name.toLowerCase() + '-label'}>
                      {language.name}
                    </span>
                  </div>
                  <div>
                    <RadioButton
                      type="radio"
                      id={`content_${language.name}`}
                      checked={language.is_default === true}
                      onChange={(event) =>
                        handleSelectionChange(event, language.l_code)
                      }
                      data-testid={
                        language.name.toLowerCase() + '-label-radio-btn'
                      }
                    />
                    <div
                      css={[
                        style.radioOuter,
                        language.is_default === true && style.activeBox
                      ]}>
                      {language.is_default === true && (
                        <div css={style.radioInner}></div>
                      )}
                    </div>
                  </div>
                </Label>
              </Row>
            );
          })
        : null}
    </>
  );
};

export default DisplayLanguage;
